import {Injectable} from '@angular/core';
import {MessageService} from 'primeng/api';
import {Message} from 'primeng/api/message';
import {TranslationService} from './translation/translation.service';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  constructor(
    private messageService: MessageService,
    private translate: TranslationService,
  ) {}

  success(detail: string, time = 5000, closable = true) {
    this.displayMessage('success', detail, time, closable);
  }

  warn(detail: string, time = 5000, closable = true) {
    this.displayMessage('warn', detail, time, closable);
  }

  error(detail: string, time = 10000, closable = true): void {
    this.displayMessage('error', detail, time, closable);
  }

  private displayMessage(
    severity: 'success' | 'warn' | 'error',
    detail: string,
    time: number,
    closable: boolean,
  ) {
    this.messageService.clear();
    const message: Message = {
      severity,
      summary: this.translate.getTranslation(severity),
      detail,
    };

    if (closable) {
      message.life = time;
      message.closable = true;
    } else {
      message.sticky = true;
    }

    this.messageService.add(message);
  }
}
